export const implementation = {
  implementationHero: {
    subtitle: 'IMPLEMENTATION',
    title: '導入について',
    description: '洗練されたシステム導入のロードマップ',
  },
  flow: {
    subtitle: 'IMPLEMENTATION FLOW',
    title: '導入の流れ',
    description: '初回相談からプログラム開始まで、体系的なアプローチを提供します。',
    individual: {
      title: '個人',
      steps: [
        {
          number: '01',
          title: '初回相談',
          description: '現状と目標のヒアリング',
        },
        {
          number: '02',
          title: 'プログラム選定',
          description: '最適なカリキュラムの選択',
        },
        {
          number: '03',
          title: '学習開始',
          description: '構造的な学習のスタート',
        },
      ],
    },
    corporate: {
      title: '企業',
      steps: [
        {
          number: '01',
          title: '組織ヒアリング',
          description: '組織課題と目標の把握',
        },
        {
          number: '02',
          title: 'カスタマイズ',
          description: '最適なプログラムの設計',
        },
        {
          number: '03',
          title: '実施・フォローアップ',
          description: 'プログラム実行と継続支援',
        },
        {
          number: '04',
          title: 'ご契約・導入',
          description: 'ご契約手続きと正式導入',
        },
      ],
    },
    educational: {
      title: '教育機関',
      steps: [
        {
          number: '01',
          title: '教育理念のすり合わせ',
          description: '機関理念との整合性確認',
        },
        {
          number: '02',
          title: 'カリキュラム統合',
          description: '既存カリキュラムとの統合',
        },
        {
          number: '03',
          title: '教育者研修・開始',
          description: '教育者トレーニングとプログラム開始',
        },
      ],
    },
  },
  faq: {
    subtitle: 'Frequently Asked Questions',
    title: 'よくある質問',
    items: [
      {
        question: '受講の対象者はどのような人ですか？',
        answer: '組織の生産性向上を目指す経営者、次世代を育成する教育関係者をはじめ、自らの成長を「構造」から設計し直したいと願う志の高い個人を対象としています。',
      },
      {
        question: '科学や心理学の専門知識は必要ですか？',
        answer: '必要ありません。DREAM CODEは、複雑な学術的知見を「誰もが再現可能なステップ」として体系化しています。専門用語の暗記ではなく、ご自身の思考と行動に落とし込む実践を重視しています。',
      },
      {
        question: '受講形式はどのようになりますか？',
        answer: '講義および実践的なワークショップを収録した映像プログラムをご提供しています。ご自身のライフスタイルやスケジュールに合わせて、時間や場所の制約なく、何度でも反復して学習・実践していただけます。',
      },
      {
        question: '全48講座の学習期間（ペース）の目安はありますか？',
        answer: '個人の理解度や実践のペースに合わせて柔軟に進行できるよう設計されています。詳細なタイムラインについては、導入時の事前面談にて最適なスケジュールをご提案いたします。',
      },
      {
        question: '企業研修や教育機関向けにカスタマイズして導入することは可能ですか？',
        answer: '可能です。組織の理念や現在の課題（リーダーシップ開発、自律型人材の育成など）をヒアリングした上で、48の法則から最適なモジュールを抽出し、専用のカリキュラムとして再構築いたします。',
      },
      {
        question: 'プログラムの受講費用と、申し込みの流れを教えてください。',
        answer: 'DREAM CODE（全48講座・基本プログラム）の受講費用は、440,000円（税込）となります。\n当アカデミーでは、受講される方の現在の課題とプログラムの適合性を重視しております。まずは「INQUIRY（事務局へのご照会）」よりご連絡ください。事前のヒアリング（または面談）を経た後、専用の受講手続きおよび決済のご案内を個別に送付申し上げます。\n※法人・教育機関向けのカスタマイズ導入については、規模と内容に応じて個別にお見積もりいたします。',
      },
    ],
    button: '事務局へ照会する',
  },
};